import { render, staticRenderFns } from "./FenceDescription.vue?vue&type=template&id=46c500fe&scoped=true"
import script from "./FenceDescription.vue?vue&type=script&lang=ts"
export * from "./FenceDescription.vue?vue&type=script&lang=ts"
import style0 from "./FenceDescription.vue?vue&type=style&index=0&id=46c500fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c500fe",
  null
  
)

export default component.exports